import { ExternalMessageOutbox } from "@/Common/Models/ExternalCommunications/GridExternalMessage";
import { ITableDataSourceItem } from "@/Common/Models/UI/Tables/ITableDataSourceItem";

class ExternalMessageOutboxTableItem implements ITableDataSourceItem<ExternalMessageOutbox> {
    public Model: ExternalMessageOutbox;
    public Name: string;

    constructor(model: ExternalMessageOutbox) {
        this.Model = model;
    }
}

export { ExternalMessageOutboxTableItem };
